import { ReactElement } from 'react';
import { connect } from 'react-redux';
//
import { setLoading } from 'store/loading/actions';
import { ELoadingType } from 'store/loading/types';
import { IStoreState } from 'store';
import UnauthorizedPage from 'pages/unauthorized/UnauthorizedPage';
import { clearModalContent, setModalContent } from 'store/modal/actions';

interface IUnauthorizedPageStateProps {
  loading: boolean;
}

interface IUnauthorizedPageDispatchProps {
  setLoading: (loading: ELoadingType) => void;
  clearModalContent: () => void;
  setModalContent: (content: ReactElement) => void;
}

export type TUnauthorizedPageProps = IUnauthorizedPageStateProps & IUnauthorizedPageDispatchProps;

const mapStateToProps = (state: IStoreState): IUnauthorizedPageStateProps => ({
  loading: state.loading.loading !== ELoadingType.NONE,
});

const mapDispatchToProps = {
  setLoading,
  setModalContent,
  clearModalContent,
};

export default connect(mapStateToProps, mapDispatchToProps)(UnauthorizedPage);
